module.exports = __webpack_public_path__ + "static/media/placeholder.f4964c1d.jpg";